module.exports = __webpack_public_path__ + "img/Lazlogo.e7c4faf1.svg";